<form *transloco="let t; read: 'authentication'">
  @if (error$ | async; as errorMessage) {
  <p class="error-msg">{{ errorMessage }}</p>
  } @if ((completed | async) === false) {
  <div>
    <mat-form-field [formGroup]="signInForm" [class.margin-bottom]="email.hasError('email')">
      <mat-label>{{ t('email') }}</mat-label>
      <input matInput type="email" formControlName="email" />
      @if (email.hasError('email')) {
      <mat-error>{{ t('error.requiredValidEmail') }}</mat-error>
      }
    </mat-form-field>
    <sibat-primary-button (clicked)="sendPasswordReset()" [label]="t('accessRetrieval')" [disabled]="signInForm.invalid">
    </sibat-primary-button>
  </div>
  } @if (completed | async) {
  <div class="completed">
    {{ t('resetLinkSent') }}
  </div>
  }
  <p><sibat-tertiary-button (clicked)="signin()" [label]="t('signin')"> </sibat-tertiary-button></p>
  <hr />
  <p>
    {{ t('noAccount') }}&nbsp;
    <sibat-link-button [href]="supportEmail" [label]="t('contactUs')" [external]="true"> </sibat-link-button>
  </p>
</form>
